import { eDisbursementType } from './eDisbursementType';

export enum eDisbursementResultStatus {
  Initiated = 'initiated',
  Staged = 'Staged',
}

export interface IDisburseResultInfo {
  disbursementId: string;
  status: string;
}

export interface IDisburseAllResult {
  achs: IDisburseResultInfo[];
  manualChecks: IDisburseResultInfo[];
  wires: IDisburseResultInfo[];
  internalTransfers: IDisburseResultInfo[];
}

export const mapDisbursementTypeToDisbursementResult = {
  [eDisbursementType.ACH]: 'achs',
  [eDisbursementType.Check]: 'manualChecks',
  [eDisbursementType.Wire]: 'wires',
  [eDisbursementType.InternalTransfer]: 'internalTransfers',
};
